<template>
<div>
  <v-card elevation="0" outlined class="pa-2 ma-3" v-if="allPrice > 0 ">
    <div :class="$isMobile ? 'size-13' : ''">合同总额： {{allPrice}}， 已开票：{{item | fmPrice}}</div>
  </v-card>
  <div class="py-2" v-if="item.length === 0">
    <img :src="require('@/assets/images/empty.png')" height="200" width="100%"/>
  </div>
  <v-card  elevation="0" outlined class="pa-2 ma-3" v-if="!showMail">
    <div>
      <v-row>
        <v-col cols="12" :md="mini ? 2 : 4" :class="$isMobile ? 'size-13' : ''">
          开票金额:<span class="warning--text size-25 font-family-Impact">{{item | fmApplyPrice}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 2 : 4" :class="$isMobile ? 'size-13' : ''">
          纳税编号：<span class="font-weight-black">{{item[0].address.taxNumber}}</span>&nbsp;
        </v-col>
        <v-col cols="12" :md="mini ? 2 : 4" :class="$isMobile ? 'size-13' : ''">
          抬头名称：<span class="font-weight-black">{{item[0].address.customerName}}</span>&nbsp;
        </v-col>
      </v-row>
    </div>
  </v-card>

  <div class="pd-c-12" v-for="(data, idx) in item" :key="idx">
    <v-row v-if="data.order !== null">
      <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
        审核状态：
        <v-chip class="mr-2" dark small :color="data.order.auditStatus | formatAuditColor">
          {{data.order.auditStatusVal}}
        </v-chip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :md="mini ? 2 : 4" :class="$isMobile ? 'size-13' : ''">
        抬头类型：<span class="font-weight-black">{{data.address.headType | formatHeadType}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 2 : 4" :class="$isMobile ? 'size-13' : ''">
        纳税编号：<span class="font-weight-black">{{data.address.taxNumber}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 8 : 4" :class="$isMobile ? 'size-13' : ''">
        抬头名称：<span class="font-weight-black">{{data.address.customerName}}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 2 : 4" :class="$isMobile ? 'size-13' : ''">
        开票金额：<span class="font-weight-black">{{data.money}}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 2 : 4" :class="$isMobile ? 'size-13' : ''">
        开票时间：<span class="font-weight-black">{{data.writeTime | formatDay}}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 8 : 4" :class="$isMobile ? 'size-13' : ''">
        发票类型：<span class="font-weight-black">{{data.typeDic.name}}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 2 : 6" :class="$isMobile ? 'size-13' : ''">
        费用明细：<span class="font-weight-black">{{data.moneyTypeDic.name}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
        地址电话：<span class="font-weight-black">{{data.address.address}}</span>
      </v-col>
    </v-row>
    <v-row>
       <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
        开户行账号：<span class="font-weight-black">{{data.address.bankName}}</span>
      </v-col>
    </v-row>
     <v-row>
      <v-col cols="12" :md="mini ? 10 : 6" :class="$isMobile ? 'size-13' : ''">
        备注信息：<span class="font-weight-black">{{data.remrk}}</span>
      </v-col>
    </v-row>
    <div v-if="showMail">
      <div class="my-5 subtitle-1 font-weight-bold">邮寄信息</div>
      <v-row>
        <v-col cols="12" :md="mini ? 2 : 4" :class="$isMobile ? 'size-13' : ''">
          联系人员：<span class="font-weight-black">{{data.address.mailPersion}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 2 : 4" :class="$isMobile ? 'size-13' : ''" >
          联系电话：<span class="font-weight-black">{{data.address.mailPhone}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 8 : 4" :class="$isMobile ? 'size-13' : ''">
          邮寄地址：<span class="font-weight-black">{{data.address.mailAddress}}</span>
        </v-col>
      </v-row>
    </div>
    <v-divider class="mt-5" v-if="idx + 1 < item.length"></v-divider>
  </div>
</div>
</template>

<script>
  export default {
    name: 'InvoiceDetail',
    components: {
    },
    filters: {
      fmPrice (item) {
        let money = 0
        item.forEach(el => {
          if (el.order.auditStatus === 1) {
            money += el.money
          }
        })
        return money
      },
      fmApplyPrice (item) {
        let money = 0
        item.forEach(el => {
          if (el.order.auditStatus === 0) {
            money += el.money
          }
        })
        return money
      }
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      },
      showMail: {
        type: Boolean,
        default: false
      },
      allPrice: {
        type: Number,
        default: 0
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    }
  }
</script>

<style>
</style>
